import * as RA from '@radix-ui/react-avatar';
import { cn } from '@/lib/utils';

export function Avatar({
  initials,
  src,
  size = 32,
  className,
}: {
  initials: string;
  src?: string;
  size?: number;
  className?: string;
}) {
  return (
    <RA.Root
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-[#22303F] font-mono font-bold text-white',
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {src && <RA.Image src={src} className="h-full w-full object-cover" alt="" />}
      <RA.Fallback>{initials}</RA.Fallback>
    </RA.Root>
  );
}
